export const ADDRESS_ERROR = "Address is a required field";
export const INVALID_VALUE = "invalid value";
export const LOCATION_ERROR = "Map location is a required field";
export const LOCATION_MUST_BE_SHORTEN_LINK = "Map location must be shorten link";
export const NAME_ERROR = "Name is a required field";
export const PHONE_NUMBER_ERROR = "Phone number should be 4, 9, 10 digits";
export const TIMEPICKER_ERROR = "Opening should be less than closing";
export const TIMEPICKER_OVER_MIDNIGHT = "Closing time should be less than or equal midnight";
